import type { LinksFunction } from '@remix-run/node'
import type { MetaFunction } from '@remix-run/react'
import { Links, Meta, Scripts } from '@remix-run/react'
import { ExternalScripts } from 'remix-utils/external-scripts'
import { Html } from '~/components/layout/Html'
import Routes from '~/routes.client'
import sonnerStylesheet from '~/sonner.css?url'
import stylesheet from '~/tailwind.css?url'
import { getPageTitle } from '~/utils/app'

export const meta: MetaFunction = ({ matches }) => [
    getPageTitle(matches),
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
]

export const links: LinksFunction = () => [
    { rel: 'stylesheet', href: stylesheet },
    { rel: 'stylesheet', href: sonnerStylesheet },
]

export default function App() {
    return (
        <Html>
            <head>
                <Meta />
                <Links />
            </head>
            <body className="relative text-primary-dark/90 dark:bg-zinc-950 dark:text-neutral-100">
                <div id="fire_app_check_[DEFAULT]" />
                <Routes />
                <Scripts />
                <ExternalScripts />
            </body>
        </Html>
    )
}
